<template>
  <div id="train">
    <div class="course-list child">
      <p class="nav" @click="toCourseList"><span class="el-icon-arrow-left"></span><span>返回</span></p>
      <div class="step-list" v-for="(c, key) in courseList">
        <div :class="{'step': true, 'active': c.passState == 'Passed', 'progress': c.passState == 'Ongoing'}">
          <div :class="{'icon': true, 'el-icon-success': c.passState == 'Passed'}" style="top: 75px !important;"></div>
          <div class="line" style="top: 92px !important;"></div>
        </div>
        <div class="content content_box" >
          <img :src="c.imageUrl" />
          <div class="box">
            <div class="title">
              <div>
                <span class="type">{{ c.categoryName }}</span>
                <span class="name">{{ c.courseName }}</span>
              </div>
              <template v-if="c.unlock">
                <div :class="{'cancel_botton':c.courseType != 'Exam'}">
                  <div v-if="c.courseType == 'Exam'&& c.passState != 'Passed' " class="status_botton" @click="toStudy(c.courseId, c.unlock, c.courseType)">开始测试</div>
                  <div v-if="c.courseType == 'Exam'&& c.passState == 'Passed' " class="status_botton" @click="toStudy(c.courseId, c.unlock, c.courseType)">重新测试</div>
                  <!-- <span v-if="c.courseType == 'Exam'">重新测试</span> -->
                  <div  class="state_posi" :class="c.passState == 'Passed'?'green':'red'">{{ c.passState == 'Passed' ? '已完成' : '未完成' }}</div>
                 <div class="start_botton" v-if="c.passState == 'Passed' && c.courseType!='Exam' && c.passState!='Study'" @click="toStudy(c.courseId, c.unlock, c.courseType)">继续学习</div>
                  <div class="start_botton" v-if="c.passState != 'Passed' && c.courseType!='Exam' && c.passState!='Study'" @click="toStudy(c.courseId, c.unlock, c.courseType)">开始学习</div>
                </div>
              </template>
              <template v-else>
                <div class="el-icon-lock"></div>
              </template>
            </div>
            <div class="text" style="height: 90px !important;">
              课程说明：{{ c.description }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <exam-dialog :visible="examVisible" :id="id" :courseId="examCourseId" :tabMajorId="tabMajorId" :majorId="majorId" :type="type" :isListPage="true" :parent="'jineng'" @callback="closeDialog"></exam-dialog>
  </div>
</template>

<script>
import examDialog from './examDialog';
export default {
  data() {
    return {
      id: this.$route.query.id, //场景id
      type: this.$route.query.type, //上级tab类型
      tabMajorId: this.$route.query.tabMajorId, //tab的id
      majorId: this.$route.query.majorId, //课程majorId
      courseList: [],
      examVisible: false, //测试考试弹出层
      examCourseId: null, //测试考试课程id
    }
  },
  components: {
    examDialog
  },
  mounted() {
    this.getCourseList();
    localStorage.setItem('majorId',this.$route.query.majorId,)
  },
  methods: {
    //获取课程列表
    getCourseList() {
      this.$http.post(API_ROOT.college + '/majors/queryCourseViewNewXlk', {'majorId': this.majorId}).then(res=> {
        var result = res.data;
        if(result.success) {
          this.courseList = result.data.data.courseViewList;
        }else {
          this.$alert(result.msg);
        }
      },res=> {
        this.$alert("AJAX请求接口异常（/majors/queryCourseViewNewXlk）！");
      })
    },
    //返回课程
    toCourseList() {
      this.$router.push({path: '/train/courseList', query: {id: this.id, type: this.type, tabMajorId: this.tabMajorId}});
    },
    toStudy(courseId, unlock, courseType) {
      if(!unlock) {
        return false;
      }
      if(courseType == 'Exam') {
        this.examVisible = true;
        this.examCourseId = courseId;
      }else {
        this.$router.push({path: '/vedioDetail', query: {id: this.id, courseId: courseId, type: this.type, majorId: this.majorId, tabMajorId: this.tabMajorId, parent: 'jineng'}});
      }
    },
    closeDialog(val) {
      this.examVisible = val;
    },
  }
}
</script>

<style lang="less" scoped>
#train {
  background: #f5f6f7;
  height: 100%;
}
.green{color: green !important; }
.red{color: red !important; }
.cancel_botton{background: #fff !important;font-weight: 600 !important;font-size: 16px;}
.start_botton{background: #497AF2;
    width: 80px;
    height: 28px;
    border-radius: 6px;
    color: #fff;
    text-align: center;
    line-height: 28px;
    cursor: pointer;position: absolute;right: 1%;bottom: 20px;
    font-weight:300 !important;}
    .content_box{position: relative;}
    .status_botton{background: #497AF2;
    width: 80px;
    height: 28px;
    border-radius: 6px;
    color: #fff;
    text-align: center;
    line-height: 28px;
    cursor: pointer;position: absolute;right: 1%;bottom: 20px;
    font-weight:300 !important;font-size: 15px !important;}
    .state_posi{margin-right:15px ;font-weight:600 !important; font-size: 16px !important;}
</style>


// WEBPACK FOOTER //
// ./src/page/train/childCourseList.vue